export default "__VITE_ASSET__D5y81edz__"